module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 28.382 33.503",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#arrow-up",
      toString: function () {
        return this.url;
      }
    }